import {
  ROLEBUTTONMENUFORM_FETCHITEMS_LOAD,
  ROLEBUTTONMENUFORM_FETCHITEMS_SUCCEED,
  ROLEBUTTONMENUFORM_ENTER_RESET,
  ROLEBUTTONMENUFORM_FETCHITEMS_FAIL,
  ROLEBUTTONMENUFORM_EDITFORM_CHANGE,
  ROLEBUTTONMENUFORM_EDITITEM_LOAD,
  ROLEBUTTONMENUFORM_EDITITEM_SUCCEED,
  ROLEBUTTONMENUFORM_EDITITEM_FAIL,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case ROLEBUTTONMENUFORM_FETCHITEMS_LOAD:
      return { ...state, isFetchButtonMenuItemsLoading: true, fetchButtonMenuItemsError: null }
    case ROLEBUTTONMENUFORM_FETCHITEMS_SUCCEED:
      return { ...state, isFetchButtonMenuItemsLoading: false, items: action.items }
    case ROLEBUTTONMENUFORM_FETCHITEMS_FAIL:
      return {
        ...state, isFetchButtonMenuItemsLoading: false, items: null, fetchButtonMenuItemsError: action.fetchButtonMenuItemsError,
      }
    case ROLEBUTTONMENUFORM_ENTER_RESET:
      return {}
    case ROLEBUTTONMENUFORM_EDITFORM_CHANGE:
      return { ...state, formFieldButtonMenuValues: { ...state.formFieldButtonMenuValues, ...action.field } }
    case ROLEBUTTONMENUFORM_EDITITEM_LOAD:
      return {
        ...state,
        isEditButtonMenuItemLoading: true,
        isEditButtonMenuItemSuccess: false,
        editButtonMenuItemError: null,
      }
    case ROLEBUTTONMENUFORM_EDITITEM_SUCCEED:
      return { ...state, isEditButtonMenuItemLoading: false, isEditButtonMenuItemSuccess: true }
    case ROLEBUTTONMENUFORM_EDITITEM_FAIL:
      return { ...state, isEditButtonMenuItemLoading: false, editButtonMenuItemError: action.editButtonMenuItemError }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/reducers/roleButtonMenuForm.js